import React from 'react';
import {recordActivity} from './services/accountActivity';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';
import 'leaflet/dist/leaflet.css';
import { registerOfflineShell } from './services/offlineShell';
import { AuthProvider, useAuth } from './services/authContext';
import { FarmProvider } from './services/farmContext';
import { GpsSessionProvider } from './services/GpsSessionContext';
import { usePersonalSettings } from './services/personalSettings';
import { GuestProvider } from './services/GuestContext';
import {RouteRecordingProvider} from './services/RouteRecordingContext';
import {GpsWorkspaceProvider} from './services/GpsWorkspaceContext';
import {initializeAppInstall} from './services/appInstall';
import {OnboardingProvider,useOnboarding} from './services/OnboardingContext';

const WorkspaceContents = () => {
  const onboarding=useOnboarding();
  const { user, privileges } = useAuth();
  const {settings,ready,save}=usePersonalSettings(user?.email);
  return <FarmProvider key={user?.email || 'signed-out'}>
    <GpsSessionProvider accountKey={user?.email||'anonymous'}
      allowed={!!user&&ready&&!!privileges.gpsTracking?.view&&onboarding.gpsReady}
      allowAutomaticPrompt={!user?.onboarding_eligible}
      enabledPreference={ready?settings.locationEnabled:undefined} onEnabledChange={async value=>{await save({locationEnabled:value});if(value!==settings.locationEnabled)recordActivity({kind:'gps.changed',enabled:value},user?.email);}}>
      <GpsWorkspaceProvider><RouteRecordingProvider><GuestProvider><App /></GuestProvider></RouteRecordingProvider></GpsWorkspaceProvider>
    </GpsSessionProvider>
  </FarmProvider>;
};
const AccountWorkspace = () => {
  const {user}=useAuth();
  return <OnboardingProvider key={user?.email||'signed-out'}><WorkspaceContents /></OnboardingProvider>;
};
initializeAppInstall();
registerOfflineShell();
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AccountWorkspace />
    </AuthProvider>
  </React.StrictMode>
);
